import { fetchCompanyTagsRoutine } from 'actions/routines/tags';
import { createIsDoingReducer } from 'store/redux';
export const finishCases = [];
export const requestCases = [fetchCompanyTagsRoutine.SUCCESS];
const hasFetchedReducer = createIsDoingReducer(finishCases, requestCases);
export default hasFetchedReducer;
